import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    system: undefined,
    appId: undefined,
    apps: [],
  },
  mutations: {
    setSystem(state, system) {
        state.system    = system;
    },
    setAppId(state, appId) {
        state.appId     = appId;
    },
    updateApps(state, apps) {
        state.apps = apps;
    }
  },
  getters: {
    appId: state => {
        return state.appId;
    },
    system: state => {
        return state.system;
    },
    apps: state => {
        return state.apps;
    }
  }

})

export default store
